module.exports = __webpack_public_path__ + "static/media/Adlai Stevenson - 1952.a642c3d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Adlai Stevenson - 1952.jpg
// module id = 429
// module chunks = 0